<div class="bn-video-player-main">
    <span
        [id]="'close-video-button'"
        (click)="closeModal()"
        class="bn-close-video-modal">
        <i class="far fa-times-circle" aria-hidden="true"></i>
    </span>
    <div class="bn-video-modal-iframe" *ngIf="video_iframe_html" [innerHtml]="video_iframe_html"></div>
</div>
